export default "__VITE_ASSET__RIB5BIRN__"